import { makeStyles } from '@material-ui/core/styles'

import { colors } from '../../theme'

export const useStyles = makeStyles(() => ({
  buttonText: {
    color: colors.textBlue,
    fontFamily: 'Mont-Heavy',
  },
  buttonOrange: {
    alignItems: 'center',
    backgroundColor: '#FF8500',
    border: '2px solid #FF8500',
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'center',
    textDecoration: 'none',
    '&:active': {
      outline: 'none',
      backgroundColor: '#F05A01 !important',
      borderColor: '#F05A01 !important',
      color: '#fff !important',
    },
    '&:active p': {
      color: '#fff !important',
    },
  },
  buttonLine: {
    alignItems: 'center',
    border: `2px solid ${colors.brandOrange}`,
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'center',
    '&:focus': {
      outline: 'none',
      backgroundColor: '#fdf3e6 !important',
      borderColor: '#f08f3f !important',
    },
    '&:focus p': {
      color: '#002898 !important',

    },
    '&:active p': {
      color: '#002898 !important',
    },
    '&:hover': {
      outline: 'none',
      backgroundColor: '#fdeedb !important',
      borderColor: '#ed7757 !important',
    },
    '&:hover p': {
      color: '#002898 !important',
    },
    '&:active': {
      outline: 'none',
      backgroundColor: '#f9d9bc !important',
      borderColor: '#ed6f37 !important',
    },
    '&:active p': {
      color: '#002898 !important',
    },
  },
}))
